export const getTicketSelectOptions = (maxCount = 10, minCount = 1, multiplier = 1) => {
  const options = [{ label: 0, value: 0 }]
  for (let i = minCount || 1; i <= Math.min(50, maxCount); i += multiplier) {
    options.push({ label: i, value: i })
  }
  return options
}

interface eventDatesInfo {
  salesStarted: boolean;
  salesEnded: boolean;
  presalesStarted: boolean;
  presalesEnded: boolean;
  presalesEnabled: boolean;
}

export const defineIsSalesClosed = (eventDatesInfo: eventDatesInfo): boolean => {
  const { salesStarted, salesEnded, presalesStarted, presalesEnded, presalesEnabled } =
    eventDatesInfo
  let isSalesClosed = false
  if (!salesStarted || (salesStarted && salesEnded)) {
    isSalesClosed = true
  }
  if (presalesEnabled) {
    if (
      (!presalesStarted && !presalesEnded) ||
      (presalesStarted && presalesEnded && !salesStarted)
    ) {
      isSalesClosed = true
    } else {
      isSalesClosed = false
    }
  }
  return isSalesClosed
}
